module.exports = __webpack_public_path__ + "static/media/san-jose.551facaa.jpg";